import { apiClient } from 'api'
import { LeagueType } from 'types/league-types'

type NewItem = Omit<LeagueType, 'id'>

export const getLeagueTypes = () => apiClient.get<LeagueType[]>('/league-types')

export const getLeagueTypeById = (id: number) => apiClient.get<LeagueType>(`/league-types/${id}`)

export const createLeagueType = (item: NewItem) => apiClient.post<NewItem, LeagueType>('/league-types', item)

export const editLeagueType = (item: LeagueType) => apiClient.patch<LeagueType>(`/league-types/${item.id}`, item)

export const deleteLeagueType = (id: number) => apiClient.delete(`/league-types/${id}`)
